/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { getAltCode } from '@utils/alternativeCode';

interface ColumnCodeProps extends Pick<ColumnCommonProps, 'question' | 'alternativeCode' | 'preferredAltCodes'> {
  handleGoToQuestion?: () => void;
}

export const ColumnCode = (props: ColumnCodeProps) => {
  const { question, handleGoToQuestion, alternativeCode, preferredAltCodes } = props;
  const universalTracker = question.universalTracker;
  const code = getAltCode(universalTracker, alternativeCode, preferredAltCodes);
  const questionTypeCode = universalTracker.getTypeCode(code);
  const questionTypeName = universalTracker.getTypeName(code);
  const tooltip = <>{questionTypeName}<br />{questionTypeCode}</>;

  return (
    <Column className='codeCol pl-3 dont_translate' truncate tooltip={tooltip} onClick={handleGoToQuestion}>
      {questionTypeCode}
    </Column>
  );
}
